document.addEventListener('DOMContentLoaded', function() {

  // Header scroll
  var header = document.querySelector('.site-header');
  if(header) window.addEventListener('scroll', function(){
    header.classList.toggle('scrolled', window.scrollY > 50);
  });

  // Cart drawer
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-overlay');

  function openCart(){ 
    if(cartDrawer) cartDrawer.classList.add('open');
    if(cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    updateCart();
  }

  function closeCart(){ 
    if(cartDrawer) cartDrawer.classList.remove('open');
    if(cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-open-cart]').forEach(function(el){
    el.addEventListener('click', function(e){ e.preventDefault(); openCart(); });
  });

  var cartClose = document.getElementById('cart-close');
  if(cartClose) cartClose.addEventListener('click', closeCart);
  if(cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Update cart
  function updateCart(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      document.querySelectorAll('.cart-count').forEach(function(el){
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
      var body = document.getElementById('cart-body');
      var total = document.getElementById('cart-total');
      if(total) total.textContent = 'AED ' + (cart.total_price/100).toFixed(2);
      if(body){
        if(cart.items.length === 0){
          body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
        } else {
          body.innerHTML = cart.items.map(function(item){
            return '<div class="cart-line" style="display:grid;grid-template-columns:70px 1fr;gap:1rem;padding:1rem 0;border-bottom:1px solid var(--border)">' +
              '<img src="'+item.image+'" alt="'+item.title+'" style="width:70px;height:70px;object-fit:cover;background:var(--bg3)">' +
              '<div><div class="cart-line-name" style="font-family:var(--font-display);font-size:0.95rem;color:var(--text);margin-bottom:0.3rem">'+item.product_title+'</div>' +
              '<div class="cart-line-price" style="font-size:0.7rem;color:var(--gold)">AED '+(item.price/100).toFixed(0)+'</div>' +
              '<button class="cart-line-remove" data-key="'+item.key+'" style="font-size:0.6rem;letter-spacing:0.15em;text-transform:uppercase;color:var(--text-dim);background:none;border:none;cursor:pointer;margin-top:0.4rem;padding:0">Remove</button>' +
              '</div></div>';
          }).join('');
          body.querySelectorAll('.cart-line-remove').forEach(function(btn){
            btn.addEventListener('click', function(){
              fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:btn.dataset.key,quantity:0})})
              .then(function(){ updateCart(); });
            });
          });
        }
      }
    });
  }

  updateCart();

  // Add to cart
  var atcForms = document.querySelectorAll('[data-atc-form]');
  atcForms.forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('.btn-atc');
      if(btn){ btn.textContent = 'Adding...'; btn.disabled = true; }
      fetch('/cart/add.js',{method:'POST',body:new FormData(form)})
      .then(function(r){ return r.json(); })
      .then(function(){
        if(btn){ btn.textContent = 'Added'; setTimeout(function(){ btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1500); }
        openCart();
      }).catch(function(){
        if(btn){ btn.textContent = 'Add to Cart'; btn.disabled = false; }
      });
    });
  });

  // Product gallery
  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImg = document.getElementById('gallery-main-img');
  thumbs.forEach(function(thumb){
    thumb.addEventListener('click', function(){
      thumbs.forEach(function(t){ t.classList.remove('active'); });
      thumb.classList.add('active');
      if(mainImg) mainImg.src = thumb.dataset.src;
    });
  });

  // Mobile menu
  var toggle = document.querySelector('.mobile-toggle');
  var mobileMenu = document.getElementById('mobile-menu');
  if(toggle && mobileMenu){
    toggle.addEventListener('click', function(){
      var open = mobileMenu.style.display === 'flex';
      mobileMenu.style.display = open ? 'none' : 'flex';
    });
  }

});
